import endpoints from './endpoints';
import { apiAction } from './api';
import { setMessage } from './message';
import { setTimecard } from './timecard';
import { RECEIPT_ANALYZE_SUCCESS, resetReceipt } from './receipt';
import { baseDraft } from '../config/staticValues';
export const SET_ENTRY = 'SET_ENTRY';
export const CLEAR_ENTRY = 'CLEAR_ENTRY';
export const DELETE_ENTRY = 'DELETE_ENTRY';
export const SAVE_ENTRY = 'SAVE_ENTRY';
export const CREATE_ENTRY = 'CREATE_ENTRY';
export const UPDATE_ENTRY = 'UPDATE_ENTRY';
export const CLEAR_ENTRY_MESSAGE = 'CLEAR_ENTRY_MESSAGE';

const initialState = { ...baseDraft };

export const setEntry = (entry) => {
  return {
    type: SET_ENTRY,
    payload: entry,
  };
};

export const createEntry = (entry, includeReceipt) => {
  return (dispatch, getState) => {
    let config = {
      url: endpoints.postEntry,
      method: 'POST',
      data: entry,
      onSuccess: [
        (payload) => setTimecard(payload.timecard),
        clearEntry,
        resetReceipt,
        () => setMessage('Saved', 'success')
      ],
      onFailure: (error) =>
        setEntry({
          ...entry,
          validationMessage:
            error?.response?.data?.validationMessage || 'Could not save - please try again'
        }),
      label: CREATE_ENTRY,
      showLoading: true,
    };
    handleReceipt(includeReceipt, config, getState);
    dispatch(apiAction(config));
  }
};

export const saveEntry = (entry, includeReceipt) => {
  return (dispatch, getState) => {
    let config = {
      url: endpoints.putEntry,
      method: 'PUT',
      data: entry,
      onSuccess: [
        (payload) => setTimecard(payload.timecard),
        clearEntry,
        resetReceipt,
        () => setMessage('Saved', 'success'),
      ],
      onFailure: (error) =>
        setEntry({
          ...entry,
          validationMessage:
            error?.response?.data?.validationMessage || 'Could not save - please try again',
        }),
      label: SAVE_ENTRY,
      showLoading: true,
    };
    handleReceipt(includeReceipt, config, getState);
    dispatch(apiAction(config));
  }
};

const handleReceipt = (includeReceipt, config, getState) => {
  if (includeReceipt) {
    const file = getState().receipt.receipt?.file;
    const markDeleted = getState().receipt.markDeleted;
    const formData = new FormData();
    formData.append("file", file);
    // if file in SQL was marked to be deleted, and there is no new file attached, then pass that to api
    if (markDeleted && !file) {
      formData.append("deleteFile", true);
    }
    config["formData"] = formData;
  }
};

export const clearEntry = (data) => {
  return {
    type: CLEAR_ENTRY,
    payload: undefined,
  };
};

export const clearEntryMessage = () => {
  return {
    type: CLEAR_ENTRY_MESSAGE,
  };
};

export const deleteEntry = (data) => {
  return apiAction({
    url: endpoints.deleteEntry,
    data: data,
    method: 'DELETE',
    onSuccess: [setTimecard, () => setMessage('Deleted', 'info')],
    label: DELETE_ENTRY,
    showLoading: true,
  });
};

export const updateEntry = (entry) => {
  return {
    type: UPDATE_ENTRY,
    payload: entry,
  };
};

export const entry = (state = initialState, action) => {
  switch (action.type) {
    case SET_ENTRY:
      return action.payload;
    case CLEAR_ENTRY:
      return initialState;
    case RECEIPT_ANALYZE_SUCCESS:
    case UPDATE_ENTRY:
      return { ...state, ...action.payload };
    case CLEAR_ENTRY_MESSAGE:
      return state.validationMessage
        ? { ...state, validationMessage: undefined }
        : state;
    default:
      return state;
  }
};
